import { render } from "./Edit.vue?vue&type=template&id=130b8069&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=130b8069&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/takayama_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130b8069"]])

export default __exports__